import {Component, h, Prop, State} from '@stencil/core';

@Component({
    tag: 'rtr-article-details-gallery-full',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RtrArticleDetailsGalleryFull {
    @Prop() name: string;
    @Prop() images: string[];
    @Prop() onShowFullGallery: (show: boolean) => void;

    @State() width: number;

    private container: HTMLDivElement;

    componentDidLoad() {
        this.width = this.container.clientWidth;
    }

    get containerLoaded() {
        return this.container;
    }

    render() {
        return (
            <div class="ADGFWrapper" ref={el => this.container = el as HTMLDivElement}>
                {this.containerLoaded && this.images.map((src) => {
                    return <rentware-image
                        src={src}
                        alt={this.name}
                        vw={this.width}
                    />
                })}
            </div>
        )
    }
}
